import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import useActions from './useActions';
import { fetchResults } from 'actions';

const useResults = () => {
  const dispatchFetchResults = useActions(fetchResults);

  const results = useSelector(
    ({ result }) => ({results: result.results, isLoading: result.isLoading}),
  );

  const memoizedFetch = useCallback(() => dispatchFetchResults({onSuccess: () => console.log("yooo")}),
    [dispatchFetchResults],
  );

  useEffect(() => {
    memoizedFetch();
  }, [memoizedFetch]);

  return results;
};

export default useResults;
